export default __webpack_public_path__ + "static/media/shoppingCar.fa2aa608.svg";